// extracted by mini-css-extract-plugin
export default {"banner":"_2YrDa","stage-notifications":"nwwz4","stageNotifications":"nwwz4"};